export default "__VITE_PUBLIC_ASSET__9064956f__"